import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen grid place-items-center text-sm text-[#78716C]"
        data-testid="auth-loading"
      >
        Loading…
      </div>
    );
  }
  if (user === false) {
    return (
      <Navigate
        to={`/auth?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/projects" replace />;
  }
  return children;
}
